import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const TypingAnimation = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentText, setCurrentText] = useState('');
  const fullText = 'AHMEDABAD NX';

  useEffect(() => {
    const hasVisited = sessionStorage.getItem('hasVisited');
    
    if (!hasVisited) {
      setIsVisible(true);
      
      // Typing animation
      let index = 0;
      const typingInterval = setInterval(() => {
        if (index < fullText.length) {
          setCurrentText(fullText.substring(0, index + 1));
          index++;
        } else {
          clearInterval(typingInterval);
          
          // Hold for 800ms then fade out
          setTimeout(() => {
            setIsVisible(false);
            sessionStorage.setItem('hasVisited', 'true');
          }, 800);
        }
      }, 75);
      
      return () => clearInterval(typingInterval);
    }
  }, []);

  if (!isVisible) return null;

  return (
    <motion.div
      data-testid="typing-overlay"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.8, ease: [0.25, 1, 0.5, 1] }}
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        backgroundImage: 'url(https://static.prod-images.emergentagent.com/jobs/ae32ccb0-3c5f-414a-b46c-cfd49c04a91f/images/d5c84624f359d64be063125228dcbf20edd00b6dab002bca476544fe4b149afd.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: 'rgba(42, 0, 0, 0.95)',
        backgroundBlendMode: 'overlay'
      }}
    >
      <div className="text-center">
        <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-[#E5A93C] tracking-wider">
          {currentText}
          <span className="animate-pulse">|</span>
        </h1>
      </div>
    </motion.div>
  );
};

export default TypingAnimation;
